module.exports = __webpack_public_path__ + "media/to-do-mvc.b2da547c.mp4";